import React, { useState } from 'react';
import { X } from 'lucide-react';
import { AnimatePresence, motion } from 'framer-motion';
const privacyContent = `
Política de Privacidad — 365 Días con Jesús

Última actualización: Enero 2025

1. Información que recopilamos
Recopilamos únicamente la información necesaria para procesar tu compra: nombre, correo electrónico y datos de pago. No almacenamos información de tarjetas de crédito.

2. Uso de la información
Tu información se utiliza exclusivamente para:
• Procesar y entregar tu compra digital
• Enviarte el enlace de descarga
• Comunicarnos contigo sobre tu pedido

3. Protección de datos
Utilizamos medidas de seguridad estándar de la industria para proteger tu información personal. No compartimos, vendemos ni alquilamos tus datos a terceros.

4. Cookies
Nuestro sitio puede utilizar cookies para mejorar tu experiencia de navegación y analizar el tráfico del sitio.

5. Tus derechos
Puedes solicitar la eliminación de tus datos personales en cualquier momento escribiéndonos por correo electrónico.

6. Cambios a esta política
Nos reservamos el derecho de actualizar esta política. Los cambios serán publicados en esta página.
`.trim();
const termsContent = `
Términos y Condiciones — 365 Días con Jesús

Última actualización: Enero 2025

1. Producto digital
"365 Días con Jesús" es un producto digital en formato PDF. Al completar tu compra, recibirás acceso inmediato para descargar el archivo.

2. Uso personal
El contenido es para uso personal y familiar. No está permitida la redistribución, reventa o reproducción del material sin autorización.

3. Garantía de devolución
Ofrecemos una garantía de devolución de 7 días desde la fecha de compra. Si no estás satisfecho/a, puedes solicitar un reembolso completo sin preguntas.

4. Propiedad intelectual
Todo el contenido, incluyendo textos, ilustraciones y diseño, está protegido por derechos de autor. Queda prohibida su reproducción total o parcial.

5. Limitación de responsabilidad
Este producto tiene fines espirituales y educativos. No sustituye asesoría profesional religiosa, psicológica ni médica.

6. Modificaciones
Nos reservamos el derecho de modificar estos términos en cualquier momento. Las modificaciones entrarán en vigor desde su publicación.

7. Ley aplicable
Estos términos se rigen por las leyes de la República de Chile.
`.trim();
type ModalType = 'privacy' | 'terms' | null;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="bg-charcoal text-white py-12 px-6 text-center" data-id="element-46">
        <div className="max-w-4xl mx-auto" data-id="element-47">
          <div className="text-2xl font-fredoka mb-6" data-id="element-48">365 Días con Jesús</div>

          <div className="flex flex-wrap justify-center gap-4 md:gap-8 text-sm text-gray-400 mb-8 font-medium" data-id="element-49">
            <button onClick={() => setActiveModal('privacy')} className="hover:text-white transition-colors cursor-pointer" data-id="element-50">
              Política de privacidad
            </button>
            <span className="hidden md:inline" data-id="element-51">|</span>
            <button onClick={() => setActiveModal('terms')} className="hover:text-white transition-colors cursor-pointer" data-id="element-52">
              Términos y condiciones
            </button>
          </div>

          <p className="text-sm text-gray-500" data-id="element-53">
            © 2025 365 Días con Jesús. Todos los derechos reservados.
          </p>
        </div>
      </footer>

      <AnimatePresence data-id="element-54">
        {activeModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" onClick={() => setActiveModal(null)} data-id="element-55">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.25
        }} className="bg-white rounded-2xl shadow-2xl max-w-2xl w-full max-h-[80vh] overflow-hidden" onClick={e => e.stopPropagation()} data-id="element-56">
              <div className="flex items-center justify-between px-6 py-4 border-b border-gray-100" data-id="element-57">
                <h2 className="font-fredoka text-xl text-charcoal" data-id="element-58">
                  {activeModal === 'privacy' ? 'Política de Privacidad' : 'Términos y Condiciones'}
                </h2>
                <button onClick={() => setActiveModal(null)} className="p-2 rounded-full hover:bg-gray-100 transition-colors" data-id="element-59">
                  <X className="w-5 h-5 text-gray-500" data-id="element-60" />
                </button>
              </div>

              <div className="px-6 py-6 overflow-y-auto max-h-[calc(80vh-72px)]" data-id="element-61">
                <pre className="whitespace-pre-wrap font-nunito text-sm text-gray-700 leading-relaxed" data-id="element-62">
                  {activeModal === 'privacy' ? privacyContent : termsContent}
                </pre>
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}